import * as React from 'react';
import ButtonLink from '@liveauctioneers/caterwaul-components/lib/ButtonLink/ButtonLink';
import { FormattedMessage } from 'react-intl';
import { getBiddingInfo } from '@/redux/modules/biddingInfo';
import { getCatalog } from '@/redux/modules/catalog';
import { isAfterStartTimeOnStartDay } from '@/utils/isAfterStartTimeOnStartDay';
import isEqual from 'react-fast-compare';
import styles from './ItemBiddingSellSimilarButton.module.scss';
import { useSelector } from 'react-redux';

type Props = {
    catalogId: number;
    itemId: number;
    sellerId: number;
};

const ItemBiddingSellSimilarButton = (props: Props) => {
    const { catalogId, itemId, sellerId } = props;

    const { isAvailable = false } = useSelector((state) => getBiddingInfo(state, itemId), isEqual);
    const { saleStartTs = 0 } = useSelector((state) => getCatalog(state, catalogId), isEqual);

    return !isAvailable && !isAfterStartTimeOnStartDay(saleStartTs) ? (
        <ButtonLink className={styles.button} secondary url={`/consignments/${sellerId}`}>
            <FormattedMessage id="sell_similar_item" />
        </ButtonLink>
    ) : null;
};

export default React.memo<Props>(ItemBiddingSellSimilarButton);
